"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFieldView = exports.MAX_STRING_LENGTH = void 0;
const input_1 = require("../../../components/input/input");
const input_state_1 = require("../../../components/input/input.state");
const input_style_1 = require("../../../components/input/input.style");
const mithril_1 = require("../../../mithril");
exports.MAX_STRING_LENGTH = 40;
function getRowsNumber(value) {
    let rows = input_1.MIN_NUMBER_ROWS;
    const lines = value.split('\n');
    if (lines.length > input_1.MIN_NUMBER_ROWS) {
        rows = 0;
        lines.forEach((line) => (rows += getRowsNumber(line)));
    }
    else if (value.length > exports.MAX_STRING_LENGTH) {
        rows = Math.ceil(value.length / exports.MAX_STRING_LENGTH);
    }
    return rows;
}
exports.TextFieldView = {
    viewInline(field) {
        const value = field.value;
        const rows = getRowsNumber(value);
        if (rows === input_1.MIN_NUMBER_ROWS) {
            return field.displayValue;
        }
        else {
            const classList = [input_style_1.CSS.container, input_style_1.CSS.MDL.container, input_style_1.CSS.isCompact];
            const className = classList.join(' ');
            const attrs = {
                className: input_style_1.CSS.input + ' ' + input_style_1.CSS.MDL.input,
                rows,
                value,
                title: value,
                disabled: true,
                style: { resize: 'none', overflow: 'hidden', outline: 'none' },
            };
            const children = [(0, mithril_1.m)('textarea', attrs)];
            return (0, mithril_1.m)('div', { className }, children);
        }
    },
    canGeocoding(field) {
        const metadata = field.collection.schema.metadata;
        if (metadata.options.address_lookup) {
            if (field.schema.id === metadata.options.address_lookup.address.field) {
                return true;
            }
        }
        return false;
    },
    viewDetail(field) {
        return null;
    },
    viewEdit(field, ctrl) {
        let inputState = ctrl.changeState.getState(field.id);
        if (inputState == null) {
            inputState = new input_state_1.InputState(field.schema.displayName);
            inputState.onValue(() => field.Mutator.manual(inputState.value));
            inputState.setValue(field.value);
            ctrl.changeState.addState(field.id, inputState);
        }
        const value = inputState.value;
        const rows = getRowsNumber(value);
        return input_1.Input.view(inputState, { rows });
    },
    hasClear(field) {
        return false;
    },
};
//# sourceMappingURL=text.field.view.js.map